module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/25/assets/images/26aa9350ecc3c0512c7dd3e6a31a4640.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_more.svg
// module id = uzN6
// module chunks = 0